import './index.scss';

document.addEventListener('DOMContentLoaded', () => {
  const signInForm = document.querySelector('form[action*="login"]') as HTMLFormElement;
  const linkedInForm = document.querySelector('form[action*="lnkd_redirect"]') as HTMLFormElement;
  const termsCheckbox = document.getElementById('user_terms_of_service') as HTMLInputElement;

  if (!signInForm || !linkedInForm || !termsCheckbox) return;

  const validateTermsAcceptance = (event: Event): void => {
    if (!termsCheckbox.checked) {
      event.preventDefault();
      termsCheckbox.classList.add('is-invalid');
    }
  };

  const resetTermsAcceptance = (): void => {
    if (termsCheckbox.checked) termsCheckbox.classList.remove('is-invalid');
  };

  termsCheckbox.addEventListener('change', resetTermsAcceptance);
  signInForm.addEventListener('submit', validateTermsAcceptance);
  linkedInForm.addEventListener('submit', validateTermsAcceptance);
});
